const global = {
  body: {
    backgroundColor: "#474747 !important",
    overflowX: "hidden" as "hidden",
    minWidth: "1200px",

    "&::-webkit-scrollbar": {
      width: "10px",
    },

    "&::-webkit-scrollbar-thumb": {
      background: "#333",
      borderRadius: "16px",
      border: "1px solid #999999",
    },
  },

  "*": {
    "&::-webkit-scrollbar": {
      width: "10px",
    },

    "&::-webkit-scrollbar-thumb": {
      background: "#333",
      borderRadius: "16px",
      border: "1px solid #999999",
    },
  },

  "&.soma-player": {
    "& video": {
      borderRadius: "12px",
      objectFit: "cover" as "cover",
    },
  },

  "&.MuiDateCalendar-root": {
    backgroundColor: "#333",
    border: "1px solid rgba(145, 158, 171, 0.08)",
    borderRadius: "16px",
    marginTop: "10px",
  },
  "&.MuiPickersDay-root": {
    backgroundColor: "#333",
    border: "none",
    color: "#fff",
    fontSize: "12px",
  },
  "&.MuiDayCalendar-weekDayLabel": {
    fontSize: "12px",
    color: "#fff",
  },
  "&.MuiPickersCalendarHeader-labelContainer": {
    color: "#fff",
  },
};

export default global;
